import { Route, Routes, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Rewads from "./pages/shitcoin-chain/ShitcoinChain";
import "bootstrap/dist/css/bootstrap.min.css";
import Partner from './pages/PartnerPage/PartnerPage'
import "./App.css";
import RewardsOptions from "./pages/Rewards/shitcoin-rewards";

const App = () => {
  return (
    <div className="wrapper">
      <Routes>
        <Route path="/" exact element={<LandingPage />} />
        <Route path="/chain" exact element={<Rewads />} />
        <Route path="/rewards" exact element={<RewardsOptions />} />
        <Route path="/partner" exact element={<Partner />} />
        <Route path="*" element={<Navigate to="/" />} />{" "}
      </Routes>
    </div>
  );
};

export default App;
